// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"5373e684","158":"0930f1e9","272":"fccd8b97","404":"854274f4","707":"0640b506"}[chunkId] + ".chunk.js";
};